import React from 'react';
import Datasheet from 'react-datasheet';
import { UPDATE } from 'admin-on-rest';
import { restClient } from '../../App';

const Sheet = ({ data, rows, idKey, identifierKey, ...props }) => {
  const isCategorySheet = props.property === 'categories';

  return (
    <Datasheet
      data={[
        [
          { readOnly: true, value: 'Identifier' },
          { readOnly: true, value: 'Acc. Name' },
          { readOnly: true, value: 'Acc. Number' },
          ...(isCategorySheet
            ? [
              {
                readOnly: true,
                value: 'Takeaway Acc. Name (default: Acc. Name)',
              },
              {
                readOnly: true,
                value: 'Takeaway Acc. Number (default: Acc. Number)',
              },
            ]
            : []),
        ],
        ...rows.map((row) => {
          const rowData = data.find((d) => d.id === row.id) || {};

          return [
            { readOnly: true, value: row[identifierKey] },
            { id: row.id, value: rowData.accountName, col: 'accountName' },
            { id: row.id, value: rowData.accountNumber, col: 'accountNumber' },
            ...(isCategorySheet
              ? [
                {
                  id: row.id,
                  value: rowData.takeAwayAccountName,
                  col: 'takeAwayAccountName',
                },
                {
                  id: row.id,
                  value: rowData.takeAwayAccountNumber,
                  col: 'takeAwayAccountNumber',
                },
              ]
              : []),
          ];
        }),
      ]}
      valueRenderer={(cell) => cell.value}
      onContextMenu={(e, cell) => (cell.readOnly ? e.preventDefault() : null)}
      onCellsChanged={(changes) => {
        const { resource, record: { venue, ...record }, property } = props;
        const values = Array.isArray(data) ? data.map((value) => ({ ...value })) : [];
        changes.forEach(({ cell, value }) => {
          const index = values.findIndex((val) => val && val.id === cell.id);
          if (index === -1) {
            values.push({ id: cell.id, [cell.col]: value });
          } else {
            values[index] = { ...values[index], [cell.col]: value };
          }
        });
        restClient(UPDATE, resource, { id: venue, data: { [property]: values, __v: record.__v } })
          .then((res) => props.afterUpdate(res.data))
          .catch((e) => props.showNotification(e.message, 'warning'));
      }}
    />
  );
};

Sheet.propTypes = {};

export default Sheet;
